<template>
  <div>
    <Header
      :header="header"
      pageIcon="directions"
      :content="content"
      :sitecode="school.site_code"
    />

    <v-container fluid>
      <v-row>
        <v-col
          cols="12"
          sm="12"
        >
          <Roadmap/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Roadmap from "../simpleComponents/Roadmap";
  import Header from '../simpleComponents/Header';
  import {mapGetters} from "vuex";

  export default {
    name: "RoadmapDashboard",
    components: {
      Header,
      Roadmap,
    },
    data: () => ({
      header: "Roadmap",
      content: "Here you will find notes for new releases and details of what you can expect to see in upcoming releases. Please note the details of upcoming releases can change without notice, to serve new user feedback requests flagged with a higher priority.<br>" +
        "<br/>If you have an idea for a new feature or improvement that you don't see here, be sure to let us know via the Feedback button in the left-side menu. The ICT PLUS team plans new releases based on feedback gathered directly from users."
    }),
    computed: {
      ...mapGetters([
        'school',
      ]),
    }
  };
</script>

<style scoped>
</style>
